'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('forum-post', {
      url: '/forum/:cat/:id',
      template: '<forum-post></forum-post>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/forum/post/post.routes.js